import { useTheme } from "styled-components";
import useMediaQuery from "./useMediaQuery";

const useBreakPoint = (breakpoint) => {
  const theme = useTheme();
  return useMediaQuery(/\([^()]+\)/g.exec(theme.mediaquery[breakpoint])[0]);
};

export default useBreakPoint;
